/**
 * @file 文档反馈hooks
 * @author Wanzhongyun
 */
import { useCallback, useEffect, useMemo, useState } from 'react';
import { fetchSubmitFeedback } from 'src/api/pages/documentApi';

import { UploadChangeParam, UploadFile } from 'antd/es/upload/interface';

const useDocFeedbackHooks = () => {
    const isFirstTimeFloatPanelVisible = useMemo((): boolean => {
        if ((window as any).sessionStorage) {
            const sessionStorage = (window as any).sessionStorage;
            const visible = sessionStorage.getItem('isFirstTimeFloatPanelVisible');
            if (!visible) {
                sessionStorage.setItem('isFirstTimeFloatPanelVisible', 'true');
            }
            return !!visible;
        }
        return false;
    }, []);

    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const [floatPanelVisible, setFloatPanelVisible] = useState<boolean>(!isFirstTimeFloatPanelVisible);
    const [questionValue, setQuestionValue] = useState<string>('');
    const [screenshotFileList, setScreenshotFileList] = useState<UploadFile[]>([]);

    const hideModal = useCallback(() => {
        setModalVisible(false);
    }, [setModalVisible]);

    const showModal = useCallback(() => {
        setModalVisible(true);
    }, [setModalVisible]);

    const onScreenshotFileListChange = useCallback((params: UploadChangeParam) => {
        setScreenshotFileList(params.fileList.slice(-1));
    }, []);

    const onSubmit = useCallback(async () => {
        let fileUrl = '';
        if (
            screenshotFileList[0] &&
            screenshotFileList[0].response &&
            screenshotFileList[0].response.result &&
            screenshotFileList[0].response.result.url
        ) {
            fileUrl = screenshotFileList[0].response.result.url;
        }

        try {
            await fetchSubmitFeedback({
                question: questionValue,
                screenshot: fileUrl,
                url: window.location.href.replace(new RegExp('^' + window.location.origin), '')
            });
        } catch (err: any) {
            // ignore
        }
        setModalVisible(false);
        setQuestionValue('');
        setScreenshotFileList([]);
    }, [questionValue, screenshotFileList, setModalVisible]);

    useEffect(() => {
        setTimeout(() => {
            setFloatPanelVisible(false);
        }, 3000);
    }, []);

    return useMemo(
        () => ({
            modalVisible,
            floatPanelVisible,
            questionValue,
            screenshotFileList,

            hideModal,
            setFloatPanelVisible,
            showModal,
            setQuestionValue,
            onScreenshotFileListChange,
            onSubmit
        }),
        [
            modalVisible,
            floatPanelVisible,
            questionValue,
            screenshotFileList,

            hideModal,
            setFloatPanelVisible,
            showModal,
            setQuestionValue,
            onScreenshotFileListChange,
            onSubmit
        ]
    );
};

export default useDocFeedbackHooks;
